import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { dataSourceAccessActionTypes, dataSourceAccessLoadingAction, dataSourceAccessLoadedAction } from "../ducks/DataSourceAccess.ducks.js";
import { getAsyncRequestStatus } from "@ane/core/lib/models";
import DataSourceResource from "../../../DataSource.resource.js";
const loadDataSourceAccessArgs = {
  filterOnType: dataSourceAccessActionTypes.LOAD,
  loadResource: (payload, state) => {
    return DataSourceResource.getDataSourceAccess(payload.workspaceId, payload.dataSourceName);
  },
  loadingAction: dataSourceAccessLoadingAction,
  loadedAction: (successData, payload, error, ec, state) => {
    const result = {
      status: getAsyncRequestStatus(error || ""),
      data: successData,
      error
    };
    return of(dataSourceAccessLoadedAction(payload, result));
  }
};
const loadDataSourceAccessEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadDataSourceAccessArgs);
const DataSourceAccessEpic = combineEpics(loadDataSourceAccessEpic);
export {
  DataSourceAccessEpic as default,
  loadDataSourceAccessEpic
};
//# sourceMappingURL=DataSourceAccessEpic.js.map
